import {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from "next";
import ErrorPage from "next/error";
import Head from "next/head";
import { useState } from "react";
import ContentNotFound from "../../components/ContentNotFound";
import Layout from "../../components/layout";
import CommonBlogPreview from "../../components/Layout/common-blog-preview";
import SEOMeta from "../../components/SEOMeta";
import BlogSidebar from "../../components/sidebar/BlogSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleDown } from "@fortawesome/free-regular-svg-icons";
import {
  getAllCatWithSlug,
  getCatData,
  getNewCatData,
  getLatestBlogs,
  getPopularBlogs,
  resolveAll,
} from "../../lib/api";

export default function Category({
  data,
  slug,
  sidebarLatestPosts,
  sidebarPopularPosts,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  if (!data) return <ErrorPage statusCode={404} />;

  const category = data[0].node;
  const catColors = data[0].node.categoryColor;
  const catPosts = category.posts;
  const latestPosts = sidebarLatestPosts.edges;
  const popularPosts = sidebarPopularPosts.edges;

  //const catStyle = {color : catColors.accentColor, backgroundColor: catColors.accentBackground}
  const catStyle = { color: catColors.accentColor };

  const firstPointer = catPosts.pageInfo.endCursor;
  const hasNextPage = catPosts.pageInfo.hasNextPage;

  const [pointer, setPointer] = useState(firstPointer);
  const [nextPage, setNextPage] = useState(hasNextPage);
  const [newCatPosts, setNewCatPosts] = useState<any[]>([]);

  // Create handleIncrement event handler
  const loadMorePosts = async () => {
    const newCD = await getNewCatData(slug as string[], pointer);

    const endPointer = newCD?.nodes[0].posts.pageInfo.endCursor;
    const ourCatPosts: any[] = newCD?.nodes[0].posts.edges;
    const hasNewPage = newCD?.nodes[0].posts.pageInfo.hasNextPage;
    setPointer(endPointer);
    setNextPage(hasNewPage);

    if (!ourCatPosts || !ourCatPosts.length) return;
    setNewCatPosts((prevState) => [...prevState, ...ourCatPosts]);
  };

  return (
    <Layout>
      <Head>
        <title>{category.seo.title}</title>
        <SEOMeta seoData={category.seo} type="category"/>
      </Head>

      <main className="blog-page-main-sec trending-post-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <header className="blog-page-dsc mb-4">
                <h2 className=" page-title text-center mt-3">
                  {category.name}
                </h2>

                {category.description && (
                  <p className=" text-center mt-3"> {category.description} </p>
                )}
              </header>
            </div>

            <div className="col-lg-8">
              <div className="celebrity-sec-card-whapper mb-5 post-grid-wrapper initialData">
                {catPosts.edges.map((posts) => (
                  <CommonBlogPreview
                    key={posts.node.slug}
                    title={posts.node.title}
                    content={posts.node.content}
                    categories={posts.node.categories}
                    coverImage={posts.node.featuredImage}
                    date={posts.node.date}
                    slug={posts.node.slug}
                  />
                ))}
                {catPosts.edges.length <= 0 && <ContentNotFound />}
              </div>

              <div className="celebrity-sec-card-whapper mb-5 post-grid-wrapper finalData">
                {newCatPosts &&
                  newCatPosts.map((data) => (
                    <CommonBlogPreview
                      key={data.node.slug}
                      title={data.node.title}
                      content={data.node.content}
                      categories={data.node.categories}
                      coverImage={data.node.featuredImage}
                      date={data.node.date}
                      slug={data.node.slug}
                    />
                  ))}
              </div>

              {nextPage == true && (
                <a onClick={loadMorePosts} className="loadMore mb-5">
                  Load More <FontAwesomeIcon icon={faCircleDown} />
                </a>
              )}
            </div>

            <div className="col-lg-4 mb-5">
              <BlogSidebar
                latestPosts={latestPosts}
                popularPosts={popularPosts}
              />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export async function getStaticProps({
  params,
  preview = false,
}: GetStaticPropsContext) {
  const limit = 5;
  const [data, sidebarLatestPosts, sidebarPopularPosts] = await resolveAll([
    getCatData(params.slug as string[]),
    getLatestBlogs(limit, preview),
    getPopularBlogs(limit, preview),
  ]);

  return {
    props: {
      preview,
      data: data.edges,
      slug: params.slug,
      sidebarLatestPosts,
      sidebarPopularPosts,
    },
    revalidate: 60 * 60 * 24,
  };
}

export async function getStaticPaths(context: GetStaticPathsContext) {
  const allCats = await getAllCatWithSlug();

  // const slugs = allCats.edges.map(({ node }) => ({
  //   slug: [node?.parent?.node?.slug, node.slug].filter((slug) => slug),
  // }));
  const slugs = allCats.edges.map(({ node }) => {
    let slugs = [node.slug];
    if (node.parent) slugs.unshift(node.parent.node.slug);
    return slugs;
  });
  let paths = slugs.map((slug) => ({ params: { slug } }));

  return {
    paths: paths,
    fallback: true,
  };
}
